import { Sparkles } from "lucide-react";

/** Zero-message placeholder shown before the first prompt. */
export function EmptyState() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-5 px-5 py-8">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="rounded-2xl border border-[#FD3E5E]/40 bg-gradient-to-br from-[#FD3E5E]/25 to-[#FF8F15]/25 p-4">
          <Sparkles className="h-8 w-8 text-[#FFB074]" />
        </div>
        <div>
          <p className="mb-1 text-sm font-semibold text-neutral-100">
            Insaion Copilot
          </p>
          <p className="max-w-[280px] text-xs leading-relaxed text-neutral-500">
            Ask anything about your fleet, incidents, dashboards and
            alarms.{" "}
          </p>
        </div>
      </div>
    </div>
  );
}
